// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__PDpT3","right":"styles_right__3ttzK"};